<template lang="html">
    <div class="dropdown" @click.stop="showOptions = !showOptions">
      <div class="trigger">
        <slot name="trigger">
        </slot>
      </div>
      <transition name="dropdown">
        <slot name="options" v-if="showOptions">
          <!-- Add the .dropdown-menu .show classes to the element filling this slot. -->
        </slot>
      </transition>
    </div>
</template>

<script>
// Generic dropdown component

export default {
  data () {
    return {
      showOptions: false
    }
  },
  mounted () {
    // detect clicks outside the dropdown
    document.body.addEventListener('click', this.hide)
  },
  beforeDestroy () {
    document.body.removeEventListener('click', this.hide)
  },
  methods: {
    hide () {
      this.showOptions = false
    }
  }
}
</script>
